<template>
  <div class="cx-layer-popup-title">
    <div class="cx-layer-popup-title-text">
      <slot name="title">
        <div class="cx-layer-popup-title-text">{{ title }}</div>
      </slot>
    </div>
    <div class="right">
      <slot name="right">
        <div class="cx-layer-popup-icon" v-if="canCancel">
          <cx-button flat icon="close" iconSize="14" @click="cancel"/>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import CxButton from '@/components/CxButton';

// Title component for CxPopup
export default {
  name: 'CxPopupTitle',
  components: {
    CxButton
  },
  props: {
    title: String,
    canCancel: { type: Boolean, default: true },
    cancel: {
      type: Function,
      default: () => {
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../common';

.cx-layer-popup-title {
  display: flex;
  background-color: @inputBackground;
  padding: 20px;
  color: @textColor;
  align-items: center;
  text-align: left;
  border-radius: 10px 10px 0 0;
  min-width: 250px;

  .cx-layer-popup-icon {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: @textColorLowlight;

    font-size: @majorFontSize;

    &:hover {
      cursor: pointer;

      span, div {
        color: @textColorHighlight !important;
      }
    }
  }


  .cx-layer-popup-title-icon-text {
    display: inline-block;
  }

  .cx-layer-popup-title-text {
    flex: 1 1 auto;
    font-size: @popupHeaderFontSize;
    text-align: center;
    color: @textColorHighlight;
    font-weight: @appFontWeight;
  }

  .right {
    .cx-layer-popup-icon {
      justify-content: flex-end;
      margin-right: 0;
    }

    flex: 0 0 20px;
  }
}

</style>